import User from "./user.model"


class Category
{
    subject: String | undefined
    userId: User = new User()
}

export class ForumTopic
{
    _id?: string | undefined
    title: string | undefined
    category: string | undefined
    description: string | undefined = ''
    tags: any[] = []
    userId: User = new User()
    parentId?: String | undefined
    votes: number | undefined
    views: number = 0
    users: [] = []
    userVotes: [] = []
    replyId: string | undefined
    quotedReply: string | undefined
    participants: string | number = 0
    quotedReplyOwner: string | undefined
    colonyId: string | undefined
    channelId: string | undefined
    hashTags: any[] = []


    static convertToForumModel = (destination: any, source: any) =>
    {

        destination._id = source._id
        destination.createdOn = source.createdOn
        destination.replyId = source.sourceId
        destination.parentId = source.postId
        destination.quotedReply = source.sourceBody
        destination.description = source.body
        destination.fullName = source.fullName
        destination.userGender = source.userGender ?? 'male'
        destination.userId = source.userId
        destination.participants = source.participants
        destination.votes = source.votes
        destination.views = source.views
        destination.title = source.title
        destination.users = source.users
        destination.userVotes = source.userVotes ?? []
        destination.profilePicture = source.userProfilePicture
        destination.quotedReplyOwner = source.sourceOwner
        destination.colonyId = source.colonyId ?? undefined
        destination.channelId = source.channelId ?? undefined
        return destination

    }
}

class Answers
{
    questionId: ForumTopic = new ForumTopic()
    answer: string | undefined
    userId: User = new User()
}

class PostForumEntity
{
    _id: string | undefined
    title: string | undefined
    description: string | undefined = ''
    tags: any[] = []
    createdOn: string | undefined
    fullName: string | undefined
    profilePicture: string | undefined
    userId: string | undefined
    userGender: string | undefined
    userName: string | undefined
}

class ForumReport
{
    forumTopicId: string | undefined
    reason: string | undefined
    detail: string | undefined

}

export { Category, Answers, PostForumEntity, ForumReport }